import { render } from "./proVisionPage.vue?vue&type=template&id=5f602b98&scoped=true"
import script from "./proVisionPage.vue?vue&type=script&lang=js"
export * from "./proVisionPage.vue?vue&type=script&lang=js"

import "./proVisionPage.vue?vue&type=style&index=0&id=5f602b98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f602b98"]])

export default __exports__